import { BaseSdk } from '../../base.sdk';
import { LinkedinProfileDto, LinkedinProfileSummaryDto } from '@andsend/services-linkedin-profiles-shared';
import { ProspectDataDto } from '@zaplify/prospects';
export class LinkedinProfilesSdk extends BaseSdk {
    async getLinkedinProfileByMemberIdOrPublicIdentifier(memberIdOrPublicIdentifier: string) {
        return await this.get<LinkedinProfileDto & { isProfilePartial: boolean }>(
            `${this.linkedinProfilesPath}/${memberIdOrPublicIdentifier}`,
        );
    }

    async getLinkedinProfilesSummary<T extends keyof LinkedinProfileSummaryDto>(params: {
        memberIds: string[];
        publicIdentifiers: string[];
        pickFields: T[];
        limit: number;
        skip: number;
    }) {
        return await this.get<Pick<LinkedinProfileSummaryDto, T>[]>(`${this.linkedinProfilesPath}/profiles-summary`, {
            params,
        });
    }

    async addFoundLinkedinProfile(params: { prospectData?: ProspectDataDto; linkedinProfile?: LinkedinProfileDto }) {
        return await this.post({
            path: `${this.linkedinProfilesPath}/found-profile`,
            payload: params,
        });
    }

    async getLinkedinConnections() {
        return await this.get<string[]>(`${this.linkedinProfilesPath}/connections`);
    }

    async patchLinkedinProfile(params: { memberId: string; linkedinProfilePictureUrl: string }) {
        return await this.patch(`${this.linkedinProfilesPath}/${params.memberId}`, {
            ...params,
        });
    }
}
